import React from 'react';
import { tv } from '@/utils/tv';

const radio = tv({
  base: 'flex size-5 shrink-0 items-center justify-center rounded-full border bg-card transition-colors',
  variants: {
    checked: { true: '', false: '' },
    disabled: { true: '', false: '' },
  },
  compoundVariants: [
    { checked: true, disabled: true, class: 'border-primary opacity-60' },
    { checked: true, disabled: false, class: 'border-primary' },
    {
      checked: false,
      disabled: true,
      class: 'border-subtle-foreground opacity-50',
    },
    { checked: false, disabled: false, class: 'border-subtle-foreground' },
  ],
});

const dot = tv({
  base: 'size-2.5 rounded-full bg-primary transition-transform duration-150 ease-out',
  variants: {
    checked: {
      true: 'scale-100',
      false: 'scale-0',
    },
  },
});

interface Props {
  checked: boolean;
  disabled?: boolean;
}

export const Radio: React.FC<Props> = ({ checked, disabled = false }) => (
  <span
    role="radio"
    aria-checked={checked}
    aria-disabled={disabled || undefined}
    className={radio({ checked, disabled })}
  >
    <span className={dot({ checked })} />
  </span>
);
